import { ReactNode } from 'react';
import { Input } from '@mantine/core';
import clsx from 'clsx';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';
import { Tooltip } from '../tooltip/Tooltip';

import styles from './form-label.module.scss';

export type FormLabelProps = {
  className?: string;
  disabled?: boolean;
  error?: string | boolean;
  /** id of associated input element to focus input on label click */
  id?: string;
  /** set to true, if label and error should be displayed inline */
  inline?: boolean;
  label?: ReactNode | ReactNode[];
  required?: boolean;
  loading?: boolean;
};

/**
 * label to be used in conjunction with an input element.
 * Returns undefined if label is empty
 */
export function FormLabel({
  className,
  id,
  label,
  error,
  inline,
  disabled,
  loading,
  required,
}: FormLabelProps) {
  if (!label) {
    return;
  }
  const withError = error && error !== '';
  return (
    <Input.Label
      htmlFor={id}
      required={required}
      className={clsx(
        className,
        styles['label'],
        withError && styles['label--error'],
        disabled && styles['label--disabled'],
        loading && styles['label--loading'],
        !disabled && !loading && styles['label--enabled']
      )}
    >
      {label}
      {withError && inline && (
        <Tooltip label={error} usePortal={false} width="200px">
          <GoogleFontIcon name="report" />
        </Tooltip>
      )}
    </Input.Label>
  );
}
